<template>
    <div class="mamMasterSubscripting page-box">
      <div class="page-content">
        <div class="vs-table-outer">
          <vs-table :noDataText="$t('root.noData')" :data="listData">
            <template
              slot="thead">
              <vs-th>
                {{$t('signal_source')}}
              </vs-th>
              <vs-th>
                {{$t('My_balance')}}
              </vs-th>
              <vs-th>
                {{$t('Allocation')}}
              </vs-th>
              <vs-th>
                {{$t('Subscription_revenue')}}
              </vs-th>
              <vs-th>
                {{$t('Subscription_yield')}}
              </vs-th>
              <vs-th>
                {{$t('Subscription_days')}}
              </vs-th>
              <vs-th
                v-if="detailsIsMaster"
              >
                {{$t('Automatic_renewal')}}
              </vs-th>
              <vs-th
                v-if="detailsIsMaster"
              >
                {{$t('Follow_the_order')}}
              </vs-th>
              <vs-th
                min-width="160px"
              >
                {{$t('Trade.oper')}}
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="index" v-for="(tr, index) in data" >
                <vs-td>
                  <div>{{tr.alias}}</div>
                  <span class="font999">{{tr.login}}</span>
                </vs-td>
                <vs-td>
                  {{tr.myBalance}}
                </vs-td>
                <vs-td>
                  {{getStrategy(tr, self)}}
                </vs-td>
                <vs-td>
                <span :class="{
                        'theme-color':   isIncludeMinus(tr.statProfit) == true,
                        'theme-green':   isIncludeMinus(tr.profitSum) == false,
                    }">{{tr.statProfit}}</span>
                </vs-td>

                <vs-td>
                <span :class="{
                        'theme-color':   isIncludeMinus(tr.efficiency) == true,
                        'theme-green':   isIncludeMinus(tr.efficiency) == false,
                    }">{{tr.efficiency}}</span>
                </vs-td>
                <vs-td>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top"
                  >
                    <div class="" slot="content">
                      {{tr.beginDate}}-
                    </div>
                    <span>{{tr.subDays}}{{$t('day')}}</span>
                  </el-tooltip>
                </vs-td>
                <vs-td
                  v-if="detailsIsMaster"
                >
                  <span>{{tr.isRenew === 1 ? $t('Yes'): $t('Not')}}</span>
                </vs-td>
                <vs-td
                  v-if="detailsIsMaster"
                >
                  <div class="icon-dot"
                       :class="{on: tr.copyStatus == 1}"
                  ></div>
                  <span
                    class="follow-order"
                    :class="{on: tr.copyStatus == 1}"
                  >{{getFollowText(tr.copyStatus)}}</span>
                </vs-td>
                <vs-td
                  min-width="160px"
                >
                  <span class="pointer handler-btn first-btn" @click.stop="editHandle(tr)">{{$t('Edit_subscription')}}</span>
                  <span class="pointer handler-btn" @click.stop="cancleHandle(tr)">{{$t('unsubscribe')}}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="pagination-outer" v-if="total">
          <div class="paginnation-left">
            <size-change @sizeChange="sizeChange"></size-change>
            <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
          </div>
          <vs-pagination
            class="pagination-box"
            :max="max"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
        </div>
      </div>
    </div>
</template>

<script>
    import { getStrategy } from '@/utils/common';
  import { removeSubscription } from '@/api/copy'
    import { mapGetters } from 'vuex'
  import { parseTime } from '@/utils/index'
  import { isIncludeMinus } from '@/utils/common';
  import initData from '@/mixins/initData';
  export default {
    name: 'index',
    mixins: [initData],
    data() {
      return {
        statistics:{
        },
        self: {}
      };
    },
    created(){
      this.self = this;
      this.$nextTick(() => {
        this.init();
      })
    },
    computed: {
      ...mapGetters(['copyingSelectData','listRefresh','detailsIsMaster']),
    },
    watch:{
      listRefresh(){
        this.init()
      }
    },
    mounted(){
      let reouterview = document.getElementById('body');
      reouterview.classList.add('hidden-scroll');
    },
    beforeDestroy(){
      let reouterview = document.getElementById('body');
      reouterview && reouterview.classList.remove('hidden-scroll');
    },
    methods: {
      parseTime,
      isIncludeMinus,
      getStrategy,
      beforeInit() {
        this.params = {
          mtId: this.$route.params.mtid,
          page: this.page -1,
          size: this.size
        };
        if (this.sort) {
          this.params.sort = this.sort;
        }
        this.url = '/crm/reception/querySubscribing';
        return true;
      },
      getFollowText(copyStatus){
        return copyStatus ? this.$t('Turned_on'): this.$t('closed');
      },
      editHandle(row){
        this.$store.commit('setCurrentMasterMtId', row.mtId);
        this.$store.commit('setMamSubEditSubscrpitParams', {
          trusteeship: row.managementAmount.replace('$',''),
          autoRenew: row.isRenew == 1 ? true : false,
          ids: row.id,
          mamCopyLogin: row.copyLogin,
          balance: row.myBalance,
        });
        this.$store.commit('setMamSubAccountEditSubscrpitDialogShow', true);
      },
      cancleHandle(row){
        this.$confirm(this.$t('mamCancleTips'), this.$t('socialSubCancelCopyButtonText'), {
          confirmButtonText: this.$t('root.confirm'),
          cancelButtonText: this.$t('root.cancle'),
          type: 'warning',
          customClass: 'self-messagebox-wrapper'
        }).then(() => {
          removeSubscription({
            id:row.id,
            closeMode: 1
          }).then((res) => {
            this.$message({
              type: 'success',
              message: this.$t('cancleSuccess')
            });
            this.init();
          })
        }).catch(() => {
          //几点取消的提示
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../../../assets/scss/variable";
.mamMasterSubscripting {
    .icon-dot {
        display: inline-block;
      margin-right: 5px;
        width: 8px;
        height: 8px;
        background-color: $themeColor;
        border-radius: 50%;
        &.on {
            background-color: $themeGreen;
        }
    }
    .follow-order {
        color: $themeColor;
        &.on {
            color: $themeGreen;
        }
    }
  .first-btn {
    padding-right: 10px;
  }
}
</style>
<style lang="scss">

</style>
